import { render, staticRenderFns } from "./TransposonFamiliesBrowse.vue?vue&type=template&id=1d474809&scoped=true"
import script from "./TransposonFamiliesBrowse.vue?vue&type=script&lang=js"
export * from "./TransposonFamiliesBrowse.vue?vue&type=script&lang=js"
import style0 from "./TransposonFamiliesBrowse.vue?vue&type=style&index=0&id=1d474809&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d474809",
  null
  
)

export default component.exports